import React, { useState, useEffect, useRef } from 'react';
import { CopyOutlined, SendOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import style from '../../AlmatyBusinessChats/AlmatyBusinessChatPreset/AlmatyBusinessChatPreset.module.css';
import ai_prep_message from '../../../assets/ai_prep_message.svg';
import ai_prep_bigger from '../../../assets/ai_prep_bigger.svg';
import { ab_master_chat } from '../../../data/ab_master_chat.js';
// FIXME RCP URL FOR AI ASSISTANT
// const apiUrl = 'https://atameken-general.metatable.ai/create_message';
// const apiUrl = 'https://atamekenvc.metatable.ai/create_message';
const authToken =
  '2b993bb5aa86d16f300224326e7f864804ddb99b2dd91f017367bc5c9aae5621';

function formatMessageText(text) {
  return text.replace(/\[([^\]]+)\]\((https?:\/\/[^\s\)\]\}]+)\)/g, (match, label, url) => {
    return `<a href="${url}" class="messageUrl" style="color: #fff; font-weight: bold" target="_blank">${url}</a>`;
  });
}

function AbMasterChat() {

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [threadId, setThreadId] = useState(null);
  const [isTyping, setIsTyping] = useState(false);
  const [containerHeight, setContainerHeight] = useState('100vh');
  const [addMargin, setAddMargin] = useState(false);
  const msgContainer = useRef();
  const [popoverOpen, setPopoverOpen] = useState(false);

  const [treadIdNew, setTreadIdNew] = useState({
    100: null,
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
    6: null,
    7: null,
    8: null,
    9: null,
    10: null,
    11: null,
    12: null,
    13: null,
    14: null,
    15: null,
    16: null,
  });

  console.log('treadIdNew', treadIdNew)




  // const [apiUrl, setApiUrl] = useState('https://ai-assistant.rbp-dev.qala-ai.com/api/gpt/0');
  const [apiUrl, setApiUrl] = useState('https://ai-assistant.rbp-dev.qala-ai.com/api/master');
  const [activeType, setActiveType] = useState(100);

  console.log('activeType', activeType)
  console.log('apiUrl', apiUrl)

  const setTreadId = (key, value) => {
    setTreadIdNew(prev => ({
      ...prev,
      [key]: value,
    }));
  }

  function updateActiveClasses(type) {
    document.querySelectorAll('.initial_item_parent').forEach(item => {
      item.classList.remove('active_initial_item_parent');
    });

    const item2 = document.getElementById(`item${type}`);
    item2.classList.add('active_initial_item_parent');
  }

  function updateActiveClassesChildren(type) {
    document.querySelectorAll('.list_item').forEach(item => {
      item.classList.remove('list_item_active');
    });

    document.querySelectorAll('.url_doc_item').forEach(item => {
      item.classList.remove('url_doc_item_active');
    });

    const item2 = document.getElementById(`item${type}`);
    item2.classList.add('list_item_active');

    const item3 = document.getElementById(`url_doc_item_${type}`);
    item3.classList.add('url_doc_item_active');

  }


  const url_docs = ab_master_chat.map(item => `
      <div class="url_doc_item" id="url_doc_item_${item.id}">
        <div class="urls" style="display: ${item.urls.length > 0 ? 'block' : 'none'}">
          <p style="margin-top: 0;">Полезные ссылки:</p>
          ${item.urls.map(el => `<div class="urls_docs_element"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1226_4134)">
              <path d="M8.56113 13.8164L1.61523 10.1394C6.66209 7.36675 12.1453 5.47613 17.8285 4.54905C16.9016 10.232 15.0112 15.715 12.2388 20.7617L8.56113 13.8164ZM8.56113 13.8164L13.0497 9.32787" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
              <clipPath id="clip0_1226_4134">
              <rect width="24" height="24" fill="white"/>
              </clipPath>
              </defs>
              </svg>
            <a href="${el.url}" target="_blank">${el.title}</a></div>`).join('')}
        </div>
        <div class="docs" style="display: ${item.docs.length > 0 ? 'block' : 'none'}">
          <p style="margin-top: 0;">Полезные документы:</p>
          ${item.docs.map(doc => `<div class="urls_docs_element"><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.8125 2.625H6.5625C5.838 2.625 5.25 3.213 5.25 3.9375V24.0625C5.25 24.787 5.838 25.375 6.5625 25.375H21.4375C22.162 25.375 22.75 24.787 22.75 24.0625V13.5625M11.8125 2.625H12.25C15.0348 2.625 17.7055 3.73125 19.6746 5.70038C21.6438 7.66951 22.75 10.3402 22.75 13.125V13.5625M11.8125 2.625C12.8568 2.625 13.8583 3.03984 14.5967 3.77827C15.3352 4.51669 15.75 5.51821 15.75 6.5625V8.3125C15.75 9.037 16.338 9.625 17.0625 9.625H18.8125C19.8568 9.625 20.8583 10.0398 21.5967 10.7783C22.3352 11.5167 22.75 12.5182 22.75 13.5625M10.5 17.5L13.125 20.125L17.5 14" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <a href="${doc.url}" target="_blank">${doc.title}</a></div>`).join('')}
        </div>
      </div>
    `).join('')

  window.setActiveType = function(type) {
    window.fastActiveType = type
    if (type < 100) {
      updateActiveClassesChildren(type)
      setActiveType(type)
      setApiUrl(`https://ai-assistant.rbp-dev.qala-ai.com/api/gpt/${type}`)
    } else {
      updateActiveClasses(type);
      if (type === 100) {
        setActiveType(type)
        setApiUrl('https://ai-assistant.rbp-dev.qala-ai.com/api/master')
        document.querySelectorAll('.initial_item_childen').forEach(item => {
          item.classList.remove('active_children');
        });
        document.querySelectorAll('.url_doc_item').forEach(item => {
          item.classList.remove('url_doc_item_active');
        });
        document.querySelectorAll('.list_item').forEach(item => {
          item.classList.remove('list_item_active');
        });
      }
    }
    if (type > 100) {
      document.querySelectorAll('.initial_item_childen').forEach(item => {
        item.classList.remove('active_children');
      });
    }
    if (type === 102 || type === 103) {
      document.getElementById(`children_${type}`).classList.add('active_children')
    }
  };



  const initialMessage = {
    text: `Здравствуйте! Я - виртуальный помощник Almaty Business Chatbot и работаю на искусственном интеллекте 🤖 <br>
            Я помогаю предпринимателям подобрать подходящую для них меру поддержки на простом и доступном языке 😊 <br>
            Выберите интересующее направление:   
            <div class="flex_row">
              <div class="initial_row" style="display: flex; flex-wrap: wrap; justify-content: flex-start" >
              
                <div class="initial_item_parent_first initial_item_parent active_initial_item_parent" id="item100"  onclick={window.setActiveType(100)}>
                  <div class='initial_item initial_item_first'  >
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 5px;">
                      <path d="M8.1775 13.7533L7.5 16.125L6.8225 13.7533C6.64739 13.1407 6.31908 12.5828 5.86855 12.1323C5.41802 11.6818 4.86012 11.3534 4.2475 11.1783L1.875 10.5L4.24667 9.8225C4.85928 9.64739 5.41718 9.31908 5.86772 8.86855C6.31825 8.41802 6.64656 7.86012 6.82167 7.2475L7.5 4.875L8.1775 7.24667C8.35261 7.85928 8.68092 8.41718 9.13145 8.86772C9.58198 9.31825 10.1399 9.64656 10.7525 9.82167L13.125 10.5L10.7533 11.1775C10.1407 11.3526 9.58282 11.6809 9.13228 12.1315C8.68175 12.582 8.35344 13.1399 8.17833 13.7525L8.1775 13.7533ZM15.2158 7.7625L15 8.625L14.7842 7.7625C14.6606 7.26799 14.405 6.81635 14.0447 6.45586C13.6843 6.09537 13.2328 5.83958 12.7383 5.71583L11.875 5.5L12.7383 5.28417C13.2328 5.16042 13.6843 4.90463 14.0447 4.54414C14.405 4.18365 14.6606 3.73201 14.7842 3.2375L15 2.375L15.2158 3.2375C15.3394 3.73211 15.5952 4.18382 15.9557 4.54432C16.3162 4.90482 16.7679 5.16056 17.2625 5.28417L18.125 5.5L17.2625 5.71583C16.7679 5.83944 16.3162 6.09518 15.9557 6.45568C15.5952 6.81618 15.3394 7.26789 15.2158 7.7625ZM14.0783 17.6392L13.75 18.625L13.4217 17.6392C13.3296 17.363 13.1745 17.1121 12.9687 16.9063C12.7629 16.7005 12.512 16.5454 12.2358 16.4533L11.25 16.125L12.2358 15.7967C12.512 15.7046 12.7629 15.5495 12.9687 15.3437C13.1745 15.1379 13.3296 14.887 13.4217 14.6108L13.75 13.625L14.0783 14.6108C14.1704 14.887 14.3255 15.1379 14.5313 15.3437C14.7371 15.5495 14.988 15.7046 15.2642 15.7967L16.25 16.125L15.2642 16.4533C14.988 16.5454 14.7371 16.7005 14.5313 16.9063C14.3255 17.1121 14.1704 17.363 14.0783 17.6392Z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Мастер-консультант
                  </div>
                </div>
              
                
                
                  <div  class="initial_item_parent" id="item102" data-id="tab_102" onclick={window.setActiveType(102)}>
                    <div class="initial_item" >
                      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.875 16.125C6.32134 16.1214 10.7483 16.7102 15.0392 17.8758C15.645 18.0408 16.25 17.5908 16.25 16.9625V16.125M3.125 4.25V4.875C3.125 5.04076 3.05915 5.19973 2.94194 5.31694C2.82473 5.43415 2.66576 5.5 2.5 5.5H1.875M1.875 5.5V5.1875C1.875 4.67 2.295 4.25 2.8125 4.25H16.875M1.875 5.5V13M16.875 4.25V4.875C16.875 5.22 17.155 5.5 17.5 5.5H18.125M16.875 4.25H17.1875C17.705 4.25 18.125 4.67 18.125 5.1875V13.3125C18.125 13.83 17.705 14.25 17.1875 14.25H16.875M1.875 13V13.3125C1.875 13.5611 1.97377 13.7996 2.14959 13.9754C2.3254 14.1512 2.56386 14.25 2.8125 14.25H3.125M1.875 13H2.5C2.66576 13 2.82473 13.0658 2.94194 13.1831C3.05915 13.3003 3.125 13.4592 3.125 13.625V14.25M16.875 14.25V13.625C16.875 13.4592 16.9408 13.3003 17.0581 13.1831C17.1753 13.0658 17.3342 13 17.5 13H18.125M16.875 14.25H3.125M12.5 9.25C12.5 9.91304 12.2366 10.5489 11.7678 11.0178C11.2989 11.4866 10.663 11.75 10 11.75C9.33696 11.75 8.70107 11.4866 8.23223 11.0178C7.76339 10.5489 7.5 9.91304 7.5 9.25C7.5 8.58696 7.76339 7.95107 8.23223 7.48223C8.70107 7.01339 9.33696 6.75 10 6.75C10.663 6.75 11.2989 7.01339 11.7678 7.48223C12.2366 7.95107 12.5 8.58696 12.5 9.25ZM15 9.25H15.0067V9.25667H15V9.25ZM5 9.25H5.00667V9.25667H5V9.25Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      Финансовые сервисы
                        
                    </div>
                    
                  </div>
                  <div  class="initial_item_parent" id="item103" onclick={window.setActiveType(103)}>
                    <div class="initial_item" >
                      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.51715 13.1417L14.3755 18C14.7922 18.4033 15.3507 18.6268 15.9306 18.6221C16.5104 18.6173 17.0653 18.3849 17.4753 17.9748C17.8854 17.5648 18.1178 17.01 18.1225 16.4301C18.1272 15.8502 17.9038 15.2917 17.5005 14.875L12.603 9.9775M9.51715 13.1417L11.5972 10.6167C11.8613 10.2967 12.2138 10.095 12.6038 9.97833C13.0622 9.84167 13.573 9.82167 14.0563 9.86167C14.7078 9.91761 15.3627 9.80222 15.9558 9.52693C16.549 9.25164 17.0598 8.82603 17.4377 8.29234C17.8156 7.75864 18.0473 7.13542 18.1099 6.4845C18.1725 5.83358 18.0639 5.17761 17.7947 4.58167L15.0647 7.3125C14.6079 7.20688 14.19 6.97514 13.8585 6.64365C13.527 6.31216 13.2953 5.89425 13.1897 5.4375L15.9197 2.7075C15.3237 2.4383 14.6677 2.32962 14.0168 2.39224C13.3659 2.45485 12.7427 2.68659 12.209 3.06446C11.6753 3.44232 11.2497 3.95318 10.9744 4.54633C10.6991 5.13948 10.5837 5.79431 10.6397 6.44583C10.7155 7.3425 10.5805 8.3325 9.88632 8.90417L9.80132 8.975M9.51715 13.1417L5.63799 17.8525C5.44998 18.0817 5.21607 18.2689 4.95132 18.4023C4.68656 18.5356 4.39683 18.612 4.10076 18.6265C3.8047 18.6411 3.50886 18.5935 3.23229 18.4869C2.95573 18.3802 2.70456 18.2168 2.49496 18.0072C2.28535 17.7976 2.12196 17.5464 2.01529 17.2699C1.90862 16.9933 1.86104 16.6975 1.87561 16.4014C1.89019 16.1053 1.96659 15.8156 2.0999 15.5508C2.23321 15.2861 2.42048 15.0522 2.64965 14.8642L8.34715 10.1725L4.92465 6.75H3.75049L1.87549 3.625L3.12549 2.375L6.25049 4.25V5.42417L9.80049 8.97417L8.34632 10.1717M15.313 15.8125L13.1255 13.625M4.05632 16.4375H4.06299V16.4442H4.05632V16.4375Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      Нефинансовые сервисы
                        
                    </div>
                   
                  </div>
                  <div  class="initial_item_parent" id="item104" onclick={window.setActiveType(104)} style="display: none;">
                    <div class="initial_item" >
                      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.61902 3.78333C8.69402 3.33167 9.08569 3 9.54402 3H10.4549C10.9132 3 11.3049 3.33167 11.3799 3.78333L11.504 4.52833C11.5624 4.88167 11.824 5.165 12.154 5.30333C12.4857 5.44 12.8665 5.42167 13.1582 5.21333L13.7724 4.77417C13.953 4.64505 14.1736 4.58423 14.3949 4.60254C14.6161 4.62085 14.8237 4.71711 14.9807 4.87417L15.6249 5.51917C15.9499 5.84333 15.9915 6.35417 15.7249 6.7275L15.2857 7.34167C15.0774 7.63333 15.059 8.01333 15.1965 8.345C15.334 8.67583 15.6174 8.93667 15.9715 8.995L16.7157 9.12C17.1682 9.195 17.499 9.58583 17.499 10.0442V10.9558C17.499 11.4142 17.1682 11.8058 16.7157 11.8808L15.9707 12.005C15.6174 12.0633 15.334 12.3242 15.1965 12.655C15.059 12.9867 15.0774 13.3667 15.2857 13.6583L15.7249 14.2733C15.9915 14.6458 15.949 15.1567 15.6249 15.4817L14.9799 16.1258C14.823 16.2827 14.6155 16.3788 14.3944 16.3971C14.1733 16.4154 13.9529 16.3547 13.7724 16.2258L13.1574 15.7867C12.8657 15.5783 12.4857 15.56 12.1549 15.6975C11.8232 15.835 11.5632 16.1183 11.504 16.4717L11.3799 17.2167C11.3049 17.6683 10.9132 18 10.4549 18H9.54319C9.08486 18 8.69402 17.6683 8.61819 17.2167L8.49486 16.4717C8.43569 16.1183 8.17486 15.835 7.84402 15.6967C7.51236 15.56 7.13236 15.5783 6.84069 15.7867L6.22569 16.2258C5.85319 16.4925 5.34236 16.45 5.01736 16.1258L4.37319 15.4808C4.21613 15.3239 4.11988 15.1163 4.10156 14.895C4.08325 14.6737 4.14407 14.4531 4.27319 14.2725L4.71236 13.6583C4.92069 13.3667 4.93902 12.9867 4.80236 12.655C4.66486 12.3242 4.38069 12.0633 4.02736 12.005L3.28236 11.88C2.83069 11.805 2.49902 11.4133 2.49902 10.9558V10.0442C2.49902 9.58583 2.83069 9.19417 3.28236 9.11917L4.02736 8.995C4.38069 8.93667 4.66486 8.67583 4.80236 8.345C4.93986 8.01333 4.92152 7.63333 4.71236 7.34167L4.27402 6.72667C4.1449 6.54604 4.08408 6.32544 4.1024 6.10416C4.12071 5.88288 4.21696 5.67528 4.37402 5.51833L5.01819 4.87417C5.17514 4.71711 5.38274 4.62085 5.60401 4.60254C5.82529 4.58423 6.04589 4.64505 6.22652 4.77417L6.84069 5.21333C7.13236 5.42167 7.51319 5.44 7.84402 5.3025C8.17486 5.165 8.43569 4.88167 8.49402 4.52833L8.61902 3.78333Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.5 10.5C12.5 11.163 12.2366 11.7989 11.7678 12.2678C11.2989 12.7366 10.663 13 10 13C9.33696 13 8.70107 12.7366 8.23223 12.2678C7.76339 11.7989 7.5 11.163 7.5 10.5C7.5 9.83696 7.76339 9.20107 8.23223 8.73223C8.70107 8.26339 9.33696 8 10 8C10.663 8 11.2989 8.26339 11.7678 8.73223C12.2366 9.20107 12.5 9.83696 12.5 10.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      Отраслевые сервисы
                    </div>
                    <div class="initial_item_childen">
                      <div class="list_item">Отраслевые сервисы</div>
                      
                    </div>
                  </div>
                  <div  class="initial_item_parent" id="item105" onclick={window.setActiveType(105)} style="display: none;">
                    <div class="initial_item" >
                      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.25 14.5625H14.0625M14.0625 14.5625H16.875M14.0625 14.5625V11.75M14.0625 14.5625V17.375M5 9.25H6.875C7.37228 9.25 7.84919 9.05246 8.20082 8.70082C8.55246 8.34919 8.75 7.87228 8.75 7.375V5.5C8.75 5.00272 8.55246 4.52581 8.20082 4.17417C7.84919 3.82254 7.37228 3.625 6.875 3.625H5C4.50272 3.625 4.02581 3.82254 3.67417 4.17417C3.32254 4.52581 3.125 5.00272 3.125 5.5V7.375C3.125 7.87228 3.32254 8.34919 3.67417 8.70082C4.02581 9.05246 4.50272 9.25 5 9.25ZM5 17.375H6.875C7.37228 17.375 7.84919 17.1775 8.20082 16.8258C8.55246 16.4742 8.75 15.9973 8.75 15.5V13.625C8.75 13.1277 8.55246 12.6508 8.20082 12.2992C7.84919 11.9475 7.37228 11.75 6.875 11.75H5C4.50272 11.75 4.02581 11.9475 3.67417 12.2992C3.32254 12.6508 3.125 13.1277 3.125 13.625V15.5C3.125 15.9973 3.32254 16.4742 3.67417 16.8258C4.02581 17.1775 4.50272 17.375 5 17.375ZM13.125 9.25H15C15.4973 9.25 15.9742 9.05246 16.3258 8.70082C16.6775 8.34919 16.875 7.87228 16.875 7.375V5.5C16.875 5.00272 16.6775 4.52581 16.3258 4.17417C15.9742 3.82254 15.4973 3.625 15 3.625H13.125C12.6277 3.625 12.1508 3.82254 11.7992 4.17417C11.4475 4.52581 11.25 5.00272 11.25 5.5V7.375C11.25 7.87228 11.4475 8.34919 11.7992 8.70082C12.1508 9.05246 12.6277 9.25 13.125 9.25Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      Прочее
                        
                    </div>
                    <div class="initial_item_childen">
                      <div class="list_item">Прочее</div>
                      
                    </div>
                  </div>
                
                
                
                
                
                  <div class="children_row">
                      <div class="initial_item_childen" id="children_102">
                        <div class="list_item" id="item1" onclick={window.setActiveType(1)}>Государственные программы</div>
                        <div class="list_item" id="item3" onclick={window.setActiveType(3)}>Банковские услуги</div>
                        <div class="list_item" id="item4" onclick={window.setActiveType(4)}>Краудфандинг</div>
                        <div class="list_item" id="item2" onclick={window.setActiveType(2)}>Венчурное финансирование</div>
                      </div>
                      
                      <div class="initial_item_childen" id="children_103">
                        <div class="list_item" id="item5" onclick={window.setActiveType(5)}>Государственная регистрация прав на недвижимое имущество</div>
                        <div class="list_item" id="item6" onclick={window.setActiveType(6)}>Подключение к сетям электроснабжения </div>
                        <div class="list_item" id="item7" onclick={window.setActiveType(7)}>Подключение к сетям теплоснабжения </div>
                        <div class="list_item" id="item8" onclick={window.setActiveType(8)}>Подключение к сетям газоснабжения </div>
                        <div class="list_item" id="item9" onclick={window.setActiveType(9)}>Подключение водоснабжения и водоотведения </div>
                        <div class="list_item" id="item10" onclick={window.setActiveType(10)}>Изменение целевого назначения ЗУ </div>
                        <div class="list_item" id="item11" onclick={window.setActiveType(11)}>Защита бизнеса </div>
                        <div class="list_item" id="item12" onclick={window.setActiveType(12)}>Бизнес план </div>
                        <div class="list_item" id="item13" onclick={window.setActiveType(13)}>Регистрация товарного знака </div>
                        <div class="list_item" id="item14" onclick={window.setActiveType(14)}>Лицензирование и аккредитация деятельности </div>
                        <div class="list_item" id="item15" onclick={window.setActiveType(15)}>Регистрация прав на интеллектуальную собственность </div>
                      
                      </div>
                  
                  </div>
                
              
             </div>  
             <div class="urls_docs" id="urls_docs" >
                ${url_docs}
             </div>
            
            </div>
                     
      `,
    fromUser: false,
  };

  const initialMessage2 = {
    text: ``,
    fromUser: false,
    hidden: true,
  };

  const initialMessage3 = {
    text: `<div style="display: flex; align-items: center"><svg width="30" height="30" viewBox="0 0 30 30"  fill="none" style="fill: yellow" xmlns="http://www.w3.org/2000/svg">
    <path style="fill: #dcdc07" d="M16.0821 3.75021L27.99 24.3753C28.3353 24.9731 28.1304 25.7376 27.5325 26.0828C27.3425 26.1925 27.1269 26.2503 26.9075 26.2503H3.0918C2.40145 26.2503 1.8418 25.6906 1.8418 25.0003C1.8418 24.7808 1.89956 24.5653 2.00927 24.3753L13.9171 3.75021C14.2623 3.15234 15.0268 2.9475 15.6246 3.29268C15.8146 3.40239 15.9725 3.56019 16.0821 3.75021ZM13.7496 20.0003V22.5003H16.2496V20.0003H13.7496ZM13.7496 11.2502V17.5003H16.2496V11.2502H13.7496Z" fill="#E75555"/>
    </svg>
     <span style="margin-left: 15px">Для углубленных ответов, выберите конкрентное направление или сферу </span></div>
      `,
    fromUser: false,
    moreMsg: true,
  };







  const preparedMessages = [
    'Какие есть меры государственной поддержки?',
    'Какие есть финансовые инструменты поддержки?',
    'Какие есть государственные программы поддержки?',
    'Какие есть меры поддержки для молодых предпринимателей?',
    'Какие есть бизнес-инкубаторы?',
    'Как получить государственную поддержку?',
    'Какие организации участвуют в программах государственной поддержки?',
  ]


  useEffect(() => {
        setMessages([initialMessage, initialMessage2, initialMessage3]);
      }, []);



  function processText(input) {
    // Разбиваем текст на строки
    const lines = input.split(/(?<=\\.)\\d+\\.\\s/); // Разделяем по номеру с точкой и пробелом
    const result = [];

    lines.forEach((line) => {
      // Убираем `**` и заменяем содержимое внутри `【】` на пустую строку
      const cleanedLine = line
        .replace(/\\*\\*/g, '')
        .replace(/【[^】]*】/g, '')
        .replace(/\*\*(.*?)\*\*/g, '<b>$1</b>')
        .replace(/(\s\d+\.)/g, '<br/>$1')
        .replace(/(\s-\s)/g, '<br/>$1');

      if (cleanedLine.trim()) {
        result.push(cleanedLine.trim());
      }
    });

    // Возвращаем текст с новой строки для каждого пункта
    return result.join('\\n');
  }

  const sendMessage = async (msg) => {
    const text = typeof msg === 'string' ? msg : input;

    if (!text.trim()) return;

    // Отображаем исходящее сообщение
    const newMessages = [...messages, { text, fromUser: true }];
    setMessages(newMessages);
    setInput('');
    setIsTyping(true);
    setTimeout(() => {
      if (msgContainer.current) {
        msgContainer.current.scrollTop = msgContainer.current.scrollHeight;
      }
    }, 0);
    // Отправляем сообщение в API
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          message: text,
          // thread_id: threadId,
          thread_id: treadIdNew[activeType],
        }),
      });
      const data = await response.json();

      // Сохраняем thread_id при первом ответе
      if (!threadId) {
        setThreadId(data.thread_id);
      }
      setTreadId(activeType, data.thread_id)

      const linkRegex = /(https?:\/\/[^\s]+)/g;
      const regextext = data.result.replace(linkRegex, (match) => {
        return `<a href="${match}" class="messageUrl" target="_blank">${match}</a>`;
      }).replace(/\n/g, "<br>");


      animateIncomingMessage(formatMessageText(data.result), newMessages);

      // Анимация печати входящего сообщения
      // animateIncomingMessage(data.result, newMessages);
    } catch (error) {
      console.error('Ошибка при запросе API:', error);
    } finally {
      setIsTyping(false);
    }
  };

  // Функция для анимации печати текста побуквенно
  const animateIncomingMessage = (text, newMessages) => {
    let index = 0;
    const intervalId = setInterval(() => {
      setMessages([
        ...newMessages,
        { text: processText(text.slice(0, index + 1)), fromUser: false },
      ]);
      index++;
      if (msgContainer.current) {
        msgContainer.current.scrollTop = msgContainer.current.scrollHeight;
      }
      if (index === text.length) {
        clearInterval(intervalId);
      }
    }, 5); // Скорость печати в миллисекундах
  };

  const changeContainerHeight = () => {
    setContainerHeight(window.visualViewport.height - 70);
  };

  useEffect(() => {
    window.visualViewport.addEventListener('resize', changeContainerHeight);
  }, []);

  const copyResponse = (message) => {
    navigator.clipboard.writeText(message);
  };

  const popoverContent = (
    <div>
      {preparedMessages.map((item) => {
        return (
          <div
            className={style.preparedMessage_popover_option}
            onClick={() => {
              sendMessage(item);
              setPopoverOpen(false);
            }}
          >
            {item}
          </div>
        );
      })}
    </div>
  );


  return (
    <>
      <div
        style={{
          ...styles.chatContainer,
          // height: containerHeight,
          // marginTop: addMargin ? '30%' : 'unset',
        }}
      >
        <div style={styles.messagesContainer} ref={msgContainer}>

          <style>
            {`
          
          .initial_row {
            margin-top: 15px;
            width: 55%;
          }
          .flex_row {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 35px;
          }
          
          .urls_docs {
            width: 40%;
          }
          .initial_item {
            transition: 0.3s;
            cursor: pointer;
            background: #6aa28a;
            padding: 10px;
            border-radius: 12px;
            margin-bottom: 0px;
            margin-right: 20px;
            display: flex;
            width: 100%;
            justify-content: center;
            // margin-top: 10px;
          }
          
          .initial_item_first {
            transition: 0.3s;
            cursor: pointer;
            background: #6aa28a;
            padding: 10px;
            border-radius: 12px;
            margin-bottom: 10px;
            margin-right: 20px;
            display: flex;
            width: 50%;
          }
          
          .initial_item_parent {
            width: 46%;
            margin-bottom: 10px;
            margin-right: 20px;
          }
          
          .initial_item_parent_first {
            width: 92%;
            margin-bottom: 0px;
            margin-right: 20px;
            display: flex;
            justify-content: flex-start;
          }
          
          .initial_item_childen {
            display: none;
          }
          
          .active_initial_item .initial_item_childen {
            display: block;
          }
          
          .active_children {
            display: flex;
            flex-wrap: wrap;
          }
          
          .children_row {
            width: 100%;
          }
          
          .initial_item svg {
          transition: .3s;
          margin-right: 5px;
          
          }
          .initial_item svg path {
          transition: .3s;
          
          }
          
          .active_initial_item {
             background: #fff;
             color: #000;
          }
          
          .active_initial_item svg {
             stroke: #000 !important;
          }
          
          .active_initial_item svg path {
             stroke: #000 !important;
          }
          
          .active_initial_item_parent .initial_item {
            background: #fff;
             color: #000;
          }
          
          .active_initial_item_parent .initial_item svg{
            stroke: #000 !important;
          }
          
          .active_initial_item_parent .initial_item  svg path {
            stroke: #000 !important;
          }
          
           .active_initial_item_parent .initial_item_childen   {
            display: block;
            display: flex;
            flex-wrap: wrap;
            
          }
          
          .initial_item_childen {
            margin-top: 10px;
          }
          
          .initial_item_childen .list_item {
            
          }
          
          .list_item {
            margin-top: 10px;
            padding-left: 10px;
            padding-right: 10px;
            padding-top: 5px;
            padding-bottom: 5px;
            border-radius: 10px;
            background: #6aa28a;
            transition: 0.3s;
            width: 90%;
            cursor: pointer;
            margin-left: 10%;
            font-size: 12px;
            margin: 0;
            margin-right: 10px;
            margin-bottom: 10px;
            width: auto;
          }
          
          .list_item:nth-child(2n) {
            // margin-right: 0;
          }
          
          .list_item:hover {
            transition: 0.3s;
            background: #fff;
            color: #000;
          }
          
          .list_item_active {
            transition: 0.3s;
            background: #fff;
            color: #000;
          }
          
          
          
          
          .initial_item:hover {
            transition: 0.3s;
            background: #fff;
            color: #000;
          }
          
           .initial_item:hover svg {
            stroke: #000 !important;
          }
          .initial_item:hover svg path{
            stroke: #000 !important;
          }
          
          .url_doc_item {
            display: none;
            justify-content: space-between;
            flex-direction: column;
          }
          
          .url_doc_item_active {
            display: flex;
          }
          
          .url_doc_item .urls {
            width: 100%;
          
          }
          
          .url_doc_item .docs {
            width: 100%;
          }
          
          .url_doc_item p {
            font-weight: 700;
          }
          
          .urls_docs_element  {
            color: #fff;
            margin-bottom: 10px;
            margin-left: 10px;
            
            display: flex;
            align-items: center;
          }
          
          .urls_docs_element a {
            color: #fff;
            font-weight: 500;
            margin-left: 5px;
            width: calc(100% - 25px)
          }
          
          .urls_docs_element svg {
            width: 25px
          }
          
            
          `}


          </style>



          <div style={styles.chatTitleBox}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
              <path d="M9.813 15.904L9 18.75L8.187 15.904C7.97687 15.1689 7.5829 14.4994 7.04226 13.9587C6.50162 13.4181 5.83214 13.0241 5.097 12.814L2.25 12L5.096 11.187C5.83114 10.9769 6.50062 10.5829 7.04126 10.0423C7.5819 9.50162 7.97587 8.83214 8.186 8.097L9 5.25L9.813 8.096C10.0231 8.83114 10.4171 9.50062 10.9577 10.0413C11.4984 10.5819 12.1679 10.9759 12.903 11.186L15.75 12L12.904 12.813C12.1689 13.0231 11.4994 13.4171 10.9587 13.9577C10.4181 14.4984 10.0241 15.1679 9.814 15.903L9.813 15.904ZM18.259 8.715L18 9.75L17.741 8.715C17.5927 8.12159 17.286 7.57962 16.8536 7.14703C16.4212 6.71444 15.8794 6.40749 15.286 6.259L14.25 6L15.286 5.741C15.8794 5.59251 16.4212 5.28556 16.8536 4.85297C17.286 4.42038 17.5927 3.87841 17.741 3.285L18 2.25L18.259 3.285C18.4073 3.87854 18.7142 4.42059 19.1468 4.85319C19.5794 5.28579 20.1215 5.59267 20.715 5.741L21.75 6L20.715 6.259C20.1215 6.40733 19.5794 6.71421 19.1468 7.14681C18.7142 7.57941 18.4073 8.12147 18.259 8.715ZM16.894 20.567L16.5 21.75L16.106 20.567C15.9955 20.2356 15.8094 19.9345 15.5625 19.6875C15.3155 19.4406 15.0144 19.2545 14.683 19.144L13.5 18.75L14.683 18.356C15.0144 18.2455 15.3155 18.0594 15.5625 17.8125C15.8094 17.5655 15.9955 17.2644 16.106 16.933L16.5 15.75L16.894 16.933C17.0045 17.2644 17.1906 17.5655 17.4375 17.8125C17.6845 18.0594 17.9856 18.2455 18.317 18.356L19.5 18.75L18.317 19.144C17.9856 19.2545 17.6845 19.4406 17.4375 19.6875C17.1906 19.9345 17.0045 20.2356 16.894 20.567Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <h3 style={styles.chatTitle}>
              Виртуальный ассистент
            </h3>
          </div>
          {messages.map((msg, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                justifyContent: index % 2 === 0 ? 'flex-start' : 'flex-end',
              }}
            >
              <div
                style={{
                  ...styles.message,
                  ...(msg.fromUser ? styles.userMessage : styles.apiMessage),
                  ...(msg.hidden ? {display: 'none'} : {display: 'block'}),
                  ...(msg.moreMsg ? {borderRadius: '18px'} : {color: '#fff'}),
                }}
              >
                <p
                  style={styles.messageText}
                  dangerouslySetInnerHTML={{ __html: msg.text }} // Используем dangerouslySetInnerHTML для отображения HTML
                />
                {!msg.fromUser && index !== 0 && (
                  <CopyOutlined
                    onClick={() => copyResponse(msg.text)}
                    style={styles.copyButton}
                  />
                )}
              </div>
            </div>
          ))}
          {isTyping && (
            <div style={styles.typingIndicator}>
              <p style={{ margin: 'unset' }}>...</p>
            </div>
          )}
        </div>
      </div>
      <div style={styles.inputContainer}>
        {preparedMessages.length > 0 ? (
          messages.length === 3 ? (
            <div style={styles.preparedMessages_wrapper}>
              <div
                style={{
                  display: 'flex',
                  columnGap: 12,
                  width:
                    preparedMessages.length * 255 +
                    (preparedMessages.length - 2) * 20,
                }}
              >
                {preparedMessages.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={styles.preparedMessage}
                      onClick={() => sendMessage(item)}
                    >
                      <div style={styles.preparedMessage_badge}>
                        <img src={ai_prep_message} />
                      </div>
                      {item}
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <Popover
              open={popoverOpen}
              content={popoverContent}
              trigger="click"
              overlayInnerStyle={styles.preparedMessage_popover}
            >
              <div
                style={styles.preparedMessage_popover_button}
                onClick={() => setPopoverOpen(!popoverOpen)}
              >
                <img src={ai_prep_bigger} />
              </div>
            </Popover>
          )
        ) : (
          ''
        )}
        <input
          onFocus={() => setAddMargin(true)}
          onBlur={() => setAddMargin(false)}
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ваш вопрос..."
          style={styles.input}
          onKeyPress={(e) => e.key === 'Enter' && sendMessage}
        />

        {/*<SendOutlined style={styles.sendButton} onClick={sendMessage} />*/}

        <button onClick={sendMessage} style={styles.sendButton}>
          Отправить
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={styles.sendButtonIcon}>
            <g clip-path="url(#clip0_1330_2465)">
              <path d="M8.56113 13.8167L1.61523 10.1396C6.66209 7.36699 12.1453 5.47638 17.8285 4.5493C16.9016 10.2323 15.0112 15.7153 12.2388 20.762L8.56113 13.8167ZM8.56113 13.8167L13.0497 9.32812" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_1330_2465">
                <rect width="24" height="24" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </button>

      </div>
    </>
  );
}

const styles = {
  chatContainer: {
    width: '100%',
    overflow: 'hidden',
    fontFamily: 'Inter',
    height: '100%',
    transition: '0.3s all',
    background: 'linear-gradient(131.19deg, #70a17e 0%, #3d7769 50% 100%)',
    padding: '10px',
    borderTopRightRadius: '45px',
    borderTopLeftRadius: '45px',
    borderRadius: '0',
  },
  chatTitleBox: {
    display: 'flex',
    alignItems: 'center',
  },
  chatTitle: {
    marginLeft: '15px',
    fontSize: '20px',
    color: '#fff'
  },
  messagesContainer: {
    maxHeight: '100%',
    overflowY: 'auto',
  },
  message: {
    marginBottom: '10px',
    padding: '8px 12px',
    maxWidth: '90%',
    width: '90%',
    display: 'inline-block',
    position: 'relative',
    color: 'red',
  },
  userMessage: {
    // backgroundColor: 'black',
    alignSelf: 'flex-end',
    textAlign: 'left',
    marginLeft: 'auto',
    color: 'white',
    borderRadius: '18px 0px 18px 18px',
    background: 'rgba(255, 255, 255, 0.3)',
  },
  apiMessage: {
    backgroundColor: '#FFF',
    border: '1px solid #e6e6e6',
    color: '#fff',
    textAlign: 'left',
    borderRadius: '0px 18px 18px 18px',
    // background: 'linear-gradient(180deg, #52876e 0%, #538872 45%)',
    background: 'rgba(255,255,255, 0.1)',
  },
  typingIndicator: {
    marginBottom: '10px',
    padding: '8px 12px',
    borderRadius: '18px 18px 18px 0px',
    display: 'inline-block',
    backgroundColor: '#e6e6e6',
    color: '#666',
    fontStyle: 'Inter',
    fontWeight: 900,
    fontSize: '16px',
    lineHeight: '24px',
  },
  messageText: {
    margin: 0,
    fontSize: '14px',
    lineHeight: '20px',
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    padding: '20px 35px',
    background: '#79a091',
    borderBottomLeftRadius: '45px',
    borderBottomRightRadius: '45px',
    borderRadius: '0',
  },
  input: {
    // flex: 1,
    padding: '10px',
    borderRadius: '12px',
    border: '1px solid #ddd',
    outline: 'none',
    fontFamily: 'Inter',
    fontSize: '16px',
    lineHeight: '24px',
    background: '#86b0a6',
    width: 'calc(100% - 165px)',
    color: '#fff'

  },
  sendButton: {
    padding: '12px 12px',
    border: 'none',
    borderRadius: '18px',
    color: '#fff',
    fontWeight: 'bold',
    cursor: 'pointer',
    position: 'absolute',
    zIndex: 1,
    right: 0,
    fontSize: 16,
    backgroundColor: '#86b0a6',
    width: '145px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginRight: '35px',

  },
  sendButtonIcon: {
    fontSize: 20,
    color: "#fff",
    order: 1
  },
  sendButtonHover: {
    backgroundColor: '#0056b3',
  },
  copyButton: {
    position: 'absolute',
    right: -25,
    color: 'grey',
    fontSize: 20,
    bottom: 0,
  },
  preparedMessages_wrapper: {
    position: 'absolute',
    bottom: '100px',
    width: '100%',
    overflowX: 'scroll',
    left: '35px'
  },
  preparedMessage: {
    background: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid #fff',
    borderRadius: '12px',
    fontSize: '14px',
    lineHeight: '21px',
    fontFamily: 'Inter',
    color: '#fff',
    padding: '15px 10px 10px 10px',
    position: 'relative',
    width: 255,
    marginTop: 15,
    cursor: 'pointer',
  },
  preparedMessage_badge: {
    position: 'absolute',
    left: '50%',
    top: '-15px',
    transform: 'translateX(-50%)',
    background: '#3d7769',
    borderRadius: '100%',
    width: 30,
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #fff',
  },
  preparedMessage_popover_button: {
    position: 'absolute',
    top: '-60px',
    right: '0',
    background: 'black',
    borderRadius: '100%',
    width: '50px',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  preparedMessage_popover: {
    background: '#fff',
    padding: 15,
  },
};

export default AbMasterChat;
